class HeroBanner {
    constructor(element) {
        this.element = element;
        this.heroContent = element.querySelector('.hero-banner__content');
        this.heroSlider = element.querySelector('.hero-banner-slider');

        this.updatePadding();
        if (this.heroSlider) this.repositionSliderNavi();

        window.addEventListener('resize', () => {
            this.updatePadding();
            if (this.heroSlider) this.repositionSliderNavi();
        });

        document.addEventListener('heroBannerIsMounted', () => {
            if (this.heroSlider) this.repositionSliderNavi();
        });
    }

    updatePadding() {
        const height = this.heroContent.offsetHeight;
        const contentOffsetPosition = window.innerWidth < 768 ? -28 : 50 / 100 * height * -1;
        this.element.style.paddingBottom =  `calc(${height + contentOffsetPosition}px + var(--y-spacing))`;
    }

    repositionSliderNavi() {
        const heroContentRect = this.heroContent.getBoundingClientRect();
        const heroContentSliderNavi = this.element.querySelector('.slider__arrows');
        const elementStyles = getComputedStyle(this.heroContent);
        const heroContentPaddingTop = elementStyles.getPropertyValue('--hero-content-padding-top').trim();
        const heroContentPaddingRight = elementStyles.getPropertyValue('--hero-content-padding-right').trim();
        const heroContentPaddingLeft = elementStyles.getPropertyValue('--hero-content-padding-left').trim();

        heroContentSliderNavi.style.top = `calc(${this.heroContent.offsetTop}px + ${heroContentPaddingTop})`;

        if (window.innerWidth >= 768) {
            heroContentSliderNavi.style.right = `calc(${document.documentElement.clientWidth}px - ${heroContentRect.right}px + ${heroContentPaddingRight})`;
            heroContentSliderNavi.style.removeProperty('width');
            heroContentSliderNavi.style.removeProperty('left');
        } else {
            heroContentSliderNavi.style.left = `calc(${heroContentRect.left}px + ${heroContentPaddingLeft})`;
            heroContentSliderNavi.style.width = `calc(${this.heroContent.offsetWidth}px - ${heroContentPaddingLeft} - ${heroContentPaddingRight})`;
            heroContentSliderNavi.style.removeProperty('right');
        }
    }

    getTranslateY(element) {
        const style = getComputedStyle(element);
        const transform = style.transform;

        if (transform && transform.startsWith('matrix')) {
            const values = transform.match(/matrix\(([^)]+)\)/)[1].split(',').map(v => parseFloat(v.trim()));
            return values[5]; // translateY
        }

        return 0;
    }
}

export default HeroBanner;